module.exports = __webpack_public_path__ + "static/media/home-page-header-md.84fb3d58.jpg";